import {AnyAction} from 'redux';
import {RECORD_CORRECT_ANSWER, RESET_CORRECT_ANSWERS_COUNT} from '../../actions/action';

export const getCorrectAnswerCount = state => state.correctAnswers;


/**
 * keep track of how many questions have been answered correctly
 * @param state
 * @param action
 */
export function correctAnswers(state: number = 0, action: AnyAction): number
{
    switch (action.type)
    {
        case RECORD_CORRECT_ANSWER:
        {
            return (state || 0) + 1;
        }

        case RESET_CORRECT_ANSWERS_COUNT:
        {
            return 0;
        }

        default:

            return state;
    }
}



// WEBPACK FOOTER //
// ./src/ts/store/reducers/questions/correctAnswers.ts